import styled from '@emotion/styled'

type ErrorMessagePropsType = {
	errorMessage?: string
}

const ErrorMessage = ({ errorMessage }: ErrorMessagePropsType) => {
	if (!errorMessage) return null
	return <Message>{errorMessage}</Message>
}

const Message = styled.span`
	display: block;
	color: #de0000;
	font-family: 'Pretendard';
	font-size: 1.4rem;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	margin-top: 0.7rem;
`

export default ErrorMessage
